// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ClsModelsEnumsRelationshipToPatient } from './clsModelsEnumsRelationshipToPatient.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ICaregiverContact {
    'dateOfBirth'?: string;
    'email'?: string;
    'firstName'?: string;
    'lastName'?: string;
    'phoneNumber'?: string;
    'relationshipToPatient'?: ClsModelsEnumsRelationshipToPatient;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ICaregiverContact>> = [
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "string"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "relationshipToPatient",
            "baseName": "relationshipToPatient",
            "type":     "ClsModelsEnumsRelationshipToPatient"
        },
    ];

    static getAttributeTypeMap() {
        return ICaregiverContact.attributeTypeMap;
    }
}
